import { Text } from 'rebass'
import { space } from 'styled-system'

const Title = props => (
    <Text
        {...props}
        css={[
            `font-weight: 500;
                width: 100%;
                color: #1c1c1b;`,
            space
        ]}>
    {props.children}
    </Text>
)
Title.defaultProps = {
    fontSize: 's'
}

export default Title
